module.exports = __webpack_public_path__ + "img/banner3.a26b2dfe.png";